import React from "react";
import Icon from "@material-ui/core/Icon";
import IconButton from "@material-ui/core/IconButton";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {useSelector} from "react-redux";
import {multiLanguageValue} from "../../../../../../../JsonScreen/Utils/lib";


const useStyles = makeStyles(() => ({
    labelContainer: {
        display: 'flex',
        alignItems: 'center'
    },
    fieldLabel: {
        flex: 'none',
        display: 'block',
    },
}));

const EntityMixedType = (props) => {
    const {properties: {label}} = props;
    const classes = useStyles();
    const {userLanguage} = useSelector(state => state.app);
    const multiLanguageLabel = multiLanguageValue(label, userLanguage)
    return (
        <div className={classes.labelContainer}>
            <label className={classes.fieldLabel}>{multiLanguageLabel}</label>
            <IconButton size={"small"} style={{marginLeft: 5}}>
                <Icon fontSize={"default"}>
                    manage_search
                </Icon>
            </IconButton>
        </div>
    )
};

export default EntityMixedType;